<template>
  <div class="data-tabs-panel-v">
    <template v-if="tabs && tabs.length">
      <el-tabs>
        <el-tab-pane v-for="(tab, index) in tabs"
                     :key="`tab-${index}`"
                     lazy>
          <template #label>
            <div class="custom-label">
              <template v-if="tab.icon">
                <i :class="tab.icon"></i>
              </template>
              <span>{{ tab.label }}</span>
            </div>
          </template>
          <template v-if="tab.content">
            <DataPanelV v-bind="tab.content"></DataPanelV>
          </template>
          <template v-else>
            <Hint type="empty">
              <div>选项卡内容为空</div>
            </Hint>
          </template>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template v-else>
      <Hint type="empty">
        <div>选项卡数量为空</div>
      </Hint>
    </template>
  </div>
</template>

<script>
import Hint from '../../Hint'
export default {
  name: 'TabsPanel',
  components: {
    DataPanelV: () => import('../DataPanelV'),
    Hint
  },
  props: {
    tabs: Array
  }
}
</script>

<style lang="scss" scoped>
.data-tabs-panel-v {
  height: 100%;

  ::v-deep .el-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;

    .el-tabs__header {
      margin-bottom: 0;
      padding: 10px 0;
      border-bottom: 1px solid #ebeef5;

      .el-tabs__nav-wrap {
        &::after {
          display: none;
        }
      }

      .el-tabs__nav {
        margin: 0 12px;
        border: none;
      }

      .el-tabs__active-bar {
        height: 100%;
        border-radius: 30px;
        z-index: 0;
      }

      .el-tabs__item {
        position: relative;
        z-index: 1;
        height: auto;
        line-height: 1;
        padding: 0 12px 0 0;
        border: none;
        border-radius: 4px;
        font-size: 13px;
        color: #606266;
        background-color: transparent;
        transition: color 0.2s;

        &:hover {
          color: inherit;
        }

        &.is-active {
          color: #fff;
        }

        .custom-label {
          display: flex;
          align-items: baseline;
          padding: 6px 12px;

          i {
            margin-left: -2px;
            margin-right: 4px;
            font-size: 13px;
          }
        }
      }
    }

    .el-tabs__content {
      flex: 1;
      overflow: auto;
      padding: 0;

      .el-tab-pane {
        height: 100%;
      }
    }
  }
}
</style>
